import { BodyText } from '@/components/BodyText';
import { TableBody } from '@mui/material';
import { ExpandableItem } from './ExpandableItem';
import { HelpLink } from './HelpLink';
import { HelpSection } from './HelpContent';
import {
  StyledTable,
  StyledTableHeadRow,
  StyledTableHeadCell,
  StyledTableRow,
  StyledTableCell,
  TableHead,
} from './HelpTable';

export const ReportsLearnView = ({ isOpen, onToggle }: { isOpen: boolean; onToggle: () => void }) => {
  return (
    <ExpandableItem
      isOpen={isOpen}
      onToggle={onToggle}
      title={<>1. Identifying duplicates and simplifying my catalog</>}
      description={
        <>
          <BodyText component='p'>
            <HelpLink to='report'>Reports</HelpLink> identify and group parts and assemblies to optimize your catalog.
            Upload your part and assembly files from the{' '}
            <HelpLink to='assets' helpSection={HelpSection.Upload}>
              Assets
            </HelpLink>{' '}
            page to get started.
          </BodyText>
          <StyledTable size='small' sx={{ marginTop: '12px' }}>
            <TableHead>
              <StyledTableHeadRow>
                <StyledTableHeadCell>Report Type</StyledTableHeadCell>
                <StyledTableHeadCell>Description</StyledTableHeadCell>
              </StyledTableHeadRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell>
                  <BodyText color='text.primary'>Duplication</BodyText>
                </StyledTableCell>
                <StyledTableCell>
                  <BodyText color='text.primary'>
                    Group duplicate parts and assemblies to identify redundancies.
                  </BodyText>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow isEven>
                <StyledTableCell>
                  <BodyText color='text.primary'>Simplification</BodyText>
                </StyledTableCell>
                <StyledTableCell>
                  <BodyText color='text.primary'>
                    Group similar parts and assemblies to standardize and reduce catalog complexity.
                  </BodyText>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>
                  <BodyText color='text.primary'>Custom</BodyText>
                </StyledTableCell>
                <StyledTableCell>
                  <BodyText color='text.primary'>
                    Group parts and assemblies with specific matching criteria for custom use-cases.
                  </BodyText>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </StyledTable>
        </>
      }
    />
  );
};
